import React from "react";
import PropTypes from "prop-types";
import UserImage from "./user_image";
import UserJobTitle from "./user_job_title";

function UserInfo(props) {
  const { user } = props;

  return (
    <a href={`/${user.name}`} rel='noreferrer noopener' className='member-link d-md-flex' data-turbolinks='false'>
      <p className='member-image-box mb-2'>
        <UserImage {...props} />
      </p>
      <div className='member-info'>
        <p className='member-name'>{user.full_name}</p>
        <UserJobTitle {...props} />
      </div>
    </a>
  );
}

UserInfo.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    full_name: PropTypes.string.isRequired
  }).isRequired
};

export default UserInfo;
